import React from 'react';
export function AddCircleIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M11 6h2v5h5v2h-5v5h-2v-5H6v-2h5V6z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1a11 11 0 100 22 11 11 0 000-22zM7 4.517a9 9 0 1110 14.966A9 9 0 017 4.517z"
  }));
}